import { readUserProfileCookie } from "./cookie";

const getUserId = () => {
  const userProfile = readUserProfileCookie();
  return userProfile ? userProfile.id : null;
};

export default getUserId;
